{
  "version": 1,
  "asset_id": "81371e56-e8e5-4712-9b1b-4dc146062f56",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/81371e56-e8e5-4712-9b1b-4dc146062f56/hiatal-type-2-story-preparation-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/81371e56-e8e5-4712-9b1b-4dc146062f56/hiatal-type-2-story-preparation-es-480.webp",
  "original_filename": "hiatal-type-2-story-preparation-es-480.webp",
  "size": 20360,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:06Z"
}
